// api/contacts.js
import api from '@/lib/api';

// Organizations
export async function fetchOrganizationById(orgId) {
  const { data } = await api.get(`/api/contacts/organizations/${orgId}/`);
  return data;
}
export async function deleteOrganization(orgId) {
  await api.delete(`/api/contacts/organizations/${orgId}/`);
}
export async function createOrganization(organizationData) {
  const { data } = await api.post(`/api/contacts/organizations/`, organizationData);
  return data;
}